// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3128) return "static/chunks/3128.f3301410d81e7a64.js";
	if (chunkId === 1427) return "static/chunks/1427.0e8cf780c4dbc534.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1575":"a1afa943746c2437","3180":"7d07511bc34ed600","3809":"69dbf3533f7b1196","4445":"2aa88526905828cb","4524":"2bcc64035374e8d5","4705":"22addc380f1d128b","5286":"a919db2ae7e49e2a","5824":"da188e6c8ab71822","6743":"e8d96fb3f985ffc6","7244":"de7e1fbd0f90e0c3","8474":"153de8c7eb3717bd","9464":"0136a57d525a4a6a"}[chunkId] + ".js";
};